module.exports = __webpack_public_path__ + "media/images/country_flags/ie-61758ec5a23e9375b17e8a1b59bdabeb.png";